import {
  Button,
  PopoverItem,
} from '@trufla-technology/trumarket-react-design-system';
import { useHistory, useParams } from 'react-router';
import { LocationsType } from '../../types/User';
import { join } from 'lodash';
import './style.scss';
import { NewLocation } from 'app/forms/NewLocation';
import { LocationCardContent } from './LocationCardContent';
import { LocationsLoading } from './LocationsLoading';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

type Props = {
  locations: LocationsType;
  refetchLocations?: () => void;
  loading?: boolean;
};

export const Locations = ({ locations, refetchLocations, loading }: Props) => {
  const { isPermitted } = useAuthContext();
  const { key: userKey } = useParams<any>();
  const history = useHistory();
  const locationsKeysString = join(
    locations?.map((location) => [location.key]),
    ',',
  );
  const openAssignToLocationPopover = () => {
    history.replace(`?new=location&userKey=${userKey}`);
  };

  if (loading) return <LocationsLoading />;

  return (
    <div className="locations-container">
      <div className="locations-container-header">
        <h3>Branches ({locations?.length})</h3>
        {isPermitted('assignUsersToLocations') && (
          <Button onClick={openAssignToLocationPopover} type="primary">
            Assign to Branches
          </Button>
        )}
      </div>

      {!locations?.length ? (
        <div className="no-locations">No Branches</div>
      ) : (
        <div className="location-list">
          {locations?.map((location) => (
            <LocationCardContent
              key={location.key}
              location={location}
              refetchLocations={refetchLocations}
            />
          ))}
        </div>
      )}

      {isPermitted('assignUsersToLocations') && (
        <PopoverItem
          title="Assign To Branches"
          match="new=location"
          showBackArrow
          component={() => (
            <NewLocation
              refetchLocations={refetchLocations}
              locationsKeysString={locationsKeysString}
            />
          )}
          onClose={() => history.push(history.location.pathname)}
        />
      )}
    </div>
  );
};
